<template>
<div class="user-profile">
    <UserProfileImage :src="user.profileImg" :guanzo="guanzo"/>
    <component :is="usernameTag" v-bind="usernameAttrs">
        {{ displayName }}
    </component>
    <span v-show="date" class="date">
        {{ date | relativeTime }}
    </span>
</div>
</template>

<script>
import UserProfileImage from '@/components/UserProfileImage'

const FALLBACK_USERNAME = 'Anonymous'

export default {
    name: 'UserProfile',
    props: {
        user: Object,
        date: String, // JSON stringified Date
        guanzo: Boolean,
    },
    computed: {
        // Keep the Anonymous fallback username for legacy posts.
        displayName: vm => vm.user.name || FALLBACK_USERNAME,
        // 2020-06-5: Realized links were incorrectly created using 'name'
        // instead of 'login'. Both can work if user never changes their
        // displayName, but it's better to use 'login' to create links.
        // Fallback to 'name' when creating links, for backwards compatibility.
        linkableName: vm => vm.user.login || vm.displayName,
        isRealUsername: vm => vm.linkableName !== FALLBACK_USERNAME,
        usernameTag: vm => vm.isRealUsername ? 'a' : 'span',
        usernameAttrs: vm => {
            const attrs = { class: 'username-link' }
            if (vm.isRealUsername) {
                attrs.href = `https://twitch.tv/${vm.linkableName}`
                attrs.target = '_blank'
            }
            return attrs
        }
    },
    components: {
        UserProfileImage,
    }
}
</script>

<style lang="scss">
#app .user-profile {
    a.username-link,
    a.username-link:hover { // specificity override...
        color: var(--text-color);
    }
}
</style>

<style lang="scss" scoped>
.user-profile {
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    overflow: hidden; // necessary to enable text-overflow ellipsis
    .profile-img, .username-link {
        margin-right: 6px;
    }
    .username-link {
        @include text-overflow-ellipsis;
    }
}

.date {
    color: rgb(130, 130, 130); // Looks fine on both themes.
    white-space: nowrap;
}
</style>
